


















import Vue from 'vue'
export default Vue.extend({
  props: {
    focusedSuggestion: {
      type: String,
      default: null
    },
    open: {
      type: Boolean,
      required: true
    },
    suggestions: {
      type: Array, // Suggestion[]
      required: true
    }
  },
  methods: {
    /**
     * @param {string} id
     */
    handleFocus(id) {
      this.$emit('focus', id)
    },
    /**
     * @param {String} id
     */
    handleSelect(id) {
      this.$emit('select', id)
    }
  }
})
